<template>
  <el-result icon="success" title="提交成功" :subTitle="subTitle">
    <template slot="extra">
      <el-button size="medium" @click="handleBack">返回列表</el-button>
      <el-button type="primary" size="medium" @click="handleProgress"
        >查看进度</el-button
      >
    </template>
  </el-result>
</template>

<script>
import { ConstantMapper, msg, approvalMsg } from './config.js'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    scenetype: {
      type: String,
    },
    dingTalkShow: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleBack() {
      this.$emit('update:visible', false)
    },
    handleProgress() {
      this.$emit('update:visible', false)
      this.$router.push({
        name: ConstantMapper.get(this.scenetype)?.toPath || '',
        query: {
          cashRefresh: true,
        },
      })
    },
  },
  computed: {
    scenetypeDesc() {
      return ConstantMapper.get(this.scenetype)?.title || '--'
    },
    subTitle() {
      if (this.dingTalkShow) return approvalMsg + this.scenetypeDesc
      return msg + this.scenetypeDesc
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .QS-icon-success {
  color: green;
  font-size: 60px;
}
</style>
